import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'appointments',
  'pay-for-account-form-appointment',
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'payment_orders',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['paymentOrderId'],
    },
    'paya',
    'accountvaults',
    {
      type: 'payload',
      selector: ['accountVaultId'],
    },
    'transactions',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmnents/requests/appointment-account-form-payment-req.js